import React from 'react';
import { Row, Col } from 'react-bootstrap';
import clsx from 'clsx';
import Carousel from 'react-multi-carousel';

import ReadMore from '../../../components/ReadMore';
import QuoteIcon from '../../../ui-core/Quote';
import useWindowWidth from '../../../hooks/useWindowWidth';
import { getDisplayType } from '../../../utils/helpers';
import { CAROUSEL_BREAKPOINT } from '../../../constants/app';

import './style.css';

const Testimonial = () => {
  const displayType = getDisplayType(useWindowWidth());
  const isMobileScreen = displayType === 'mobile';
  const isIpadScreen = displayType === 'ipad';
  const testimonials = [
    {
      testimonial:
        'I have learned a lot in just two weeks and my feet feel so much better already! If anyone out there is struggling with foot or ankle pain this course is a game changer!',
      name: 'Kia',
    },
    {
      testimonial:
        "To say I have enjoyed this course is an understatement. I've learned more in the last 14 days than I have during ANY of my doctor's visits! Thank you Doc J for sharing your GIFT with us!",
      name: 'Monique',
    },
    {
      testimonial:
        'Thanks so much for this amazing course Dr. Jen. Though I remembered some of these movements from my PT, the way you explained the science behind them and self assessment to figure out our foot mechanism was amazing! So glad I signed up for this course!',
      name: '@healthy_me_barefoot',
    },
    {
      testimonial:
        "This was the best decision ever!!! I am walking without pain first thing in the morning, I'm paying attention to my feet, my alignment, my balance and what my body is saying. I learned so much!",
      name: '@healthy.thy.now',
    },
  ];

  const renderTestimonials = () => {
    const testimonialsOutput = testimonials?.map((item, index) => (
      <div
        key={`testimonial-${index + 1}`}
        className="item postion-relative d-flex flex-column justify-content-between"
      >
        {isMobileScreen ? (
          Array.from({ length: 4 }).map((_, index) => (
            <div
              style={{
                right: '40px',
                top: '-15px',
              }}
              className="position-absolute"
              key={`testimonial-item-${index + 1}`}
            >
              <QuoteIcon key={`quote-icon-${index + 1}`} />
            </div>
          ))
        ) : (
          <div
            style={{
              right: '40px',
              top: '-15px',
            }}
            className="position-absolute"
          >
            <QuoteIcon />
          </div>
        )}
        <ReadMore
          readMoreText="View More"
          readLessText="Less"
          text={item.testimonial}
          textLimit={isIpadScreen ? 150 : isMobileScreen ? 165 : 195}
        />
        <p className="name-para">{item.name}</p>
      </div>
    ));
    return testimonialsOutput;
  };

  return (
    <section
      className={clsx(
        !isMobileScreen
          ? 'home-testimonial full-body-testimonials'
          : 'pt-5 home-testimonial full-body-testimonials',
      )}
    >
      <div className="container">
        <Row>
          <Col>
            <h3 className="text-center mb-0 h-3 ms-5 me-5 sec-head">
              Testimonials
            </h3>
          </Col>
        </Row>
        <Row className={clsx('px-lg-5', isMobileScreen && 'mt-3')}>
          <Col className="position-relative">
            {isMobileScreen ? (
              <div className="doctors-advice d_c">{renderTestimonials()}</div>
            ) : (
              <Carousel
                responsive={CAROUSEL_BREAKPOINT}
                className="doctors-advice d_c"
                showDots={true}
                swipeable={isMobileScreen || isIpadScreen}
                draggable={isMobileScreen || isIpadScreen}
              >
                {renderTestimonials()}
              </Carousel>
            )}
          </Col>
        </Row>
      </div>
    </section>
  );
};

export default Testimonial;
